<template>
    <div class="placeholder-selector-wrapper">
        <ul class="list-group">
            <li class="list-group-item d-flex align-items-center justify-content-between">
                <span>
                    <strong> Page </strong>
                </span>
                <span class="w-50">
                    <strong> POD Placeholder </strong>
                </span>
            </li>
            <li
                v-for="(tpPlaceholder, idx) in templateProductPlaceholders"
                :id="`tpPlaceholder-${idx}-${tpPlaceholder.epsId}`"
                :key="`tpPlaceholder-${idx}-${tpPlaceholder.epsId}`"
                class="list-group-item d-flex align-items-center justify-content-between"
            >
                <span>
                    {{ tpPlaceholder.epsName }}
                </span>
                <c-dropdown
                    class="w-50"
                    :options="providerPlaceholders"
                    :value="tpPlaceholder.providerPlaceholderId || ''"
                    placeholder="Select a placeholder"
                    name="providerPlaceholder"
                    @input="placeholderSelected($event, idx)"
                />
            </li>
        </ul>
    </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import CDropdown from '@/components/CDropdown.vue';

const emit = defineEmits(['placeholder-selected']);

const props = defineProps<{
    providerPlaceholders: string[];
    templateProductPlaceholders: {
        epsId: number;
        epsName: string;
        providerPlaceholderId: string;
    }[];
}>();

const providerPlaceholders = computed(() => {
    return props.providerPlaceholders.map((placeholder) => ({
        value: placeholder,
        text: placeholder
    }));
});
const placeholderSelected = (value: unknown, idx: number) => {
    emit('placeholder-selected', value, idx);
};
</script>
